export const currencySymbolMap: Record<string, string> = {
  USD: '$',
  GBP: '£',
  INR: '₹',
};
